import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Te pasás horas armando planes "perfectos" y terminás agotado/a', 'En consulta mirás mil variables y te perdés en el diagnóstico nutricional', 'Te trabás cuando el paciente no baja / no mejora / no cumple', 'Explicás, explicás… y el paciente igual "no lo hace"', 'Adaptar un plan te lleva demasiado, entonces terminás reciclando lo mismo', 'El seguimiento se vuelve improvisación + intuición + culpa', 'Sabés que podrías cobrar mejor, pero te falta un sistema visible y profesional'];
  return <section className="pt-8 pb-12 bg-surface" data-id="element-185">
      <div className="max-w-4xl mx-auto px-4" data-id="element-186">
        <FadeIn data-id="element-187">
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-6 text-center text-mint" data-id="element-188">
            Si sos nutricionista, esto te va a sonar familiar:
          </h2>
        </FadeIn>

        <div className="space-y-4 mb-4" data-id="element-189">
          {points.map((point, idx) => <FadeIn key={idx} delay={idx * 0.1} className="flex items-start gap-4 bg-white/5 p-4 rounded-lg border border-red-500/20" data-id="element-190">
              <XCircle className="text-red-400 shrink-0 mt-0.5" size={24} data-id="element-191" />
              <p className="text-lg md:text-xl font-medium text-white" data-id="element-192">
                {point}
              </p>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-193">
          <p className="text-center text-2xl md:text-3xl italic max-w-2xl mx-auto font-[900] font-['Open_Sans',_sans-serif] text-[#B8E6C8]" data-id="element-194">
            ¿Cuántos domingos más vas a perder pensando en tus pacientes?
          </p>
        </FadeIn>
      </div>
    </section>;
}